module.exports = __webpack_public_path__ + "static/assets/11c6618c04716c35940f2a2c08c8558b.jpg";